import React from "react";

import { FiCamera, FiZap } from "react-icons/fi";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const SelfiePage = ({
  setScreen,
  setSelfieFaceReady,
  setSelfieError,
  setSelfieHint,
}) => {
  return (
    <section className="fw-screen fw-screen--selfie fw-fade">
           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      <h1 className="fw-title">
        Take a Selfie 
      </h1>

      <div
        className="fw-selfie-intro__art"
        aria-hidden="true"
      >
        <span className="fw-selfie-intro__glow" />

        <svg
          viewBox="0 0 180 180"
          fill="none"
          className="fw-selfie-intro__svg"
        >
          <circle
            cx="90"
            cy="90"
            r="78"
            fill="#f3f0f8"
          />

          <circle
            cx="90"
            cy="90"
            r="78"
            stroke="#e4dff5"
            strokeWidth="1.5"
            strokeDasharray="5 7"
          />

          <ellipse
            cx="90"
            cy="74"
            rx="34"
            ry="38"
            fill="#fff"
            stroke="#c8c4dc"
            strokeWidth="2.5"
          />

          <path
            d="M48 148c10-24 28-36 42-36s32 12 42 36"
            fill="#fff"
            stroke="#c8c4dc"
            strokeWidth="2.5"
            strokeLinecap="round"
          />

          <circle
            cx="78"
            cy="70"
            r="3"
            fill="#6b68a6"
          />

          <circle
            cx="102"
            cy="70"
            r="3"
            fill="#6b68a6"
          />

          <path
            d="M82 86c4 5 12 5 16 0"
            stroke="#6b68a6"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <div className="fw-selfie-tips">
        <h2>Quick tip for you</h2>

        <div className="fw-selfie-tip">
          <span className="fw-selfie-tip__icon">
            <FiCamera />
          </span>

          <p>
            Allow camera permission to take a
            selfie to be matched with KYC records.
          </p>
        </div>

        <div className="fw-selfie-tip">
          <span className="fw-selfie-tip__icon">
            <FiZap />
          </span>

          <p>
            Click a selfie in a well-lit
            environment. Avoid wearing a cap,
            glasses or mask.
          </p>
        </div>
      </div>

      <div className="fw-selfie-safe">
        <strong>
          100% Safe and Secure
        </strong>

        <p>
          The data shared will be encrypted,
          stored securely, and only used to
          verify your identity.
        </p>
      </div>

      <div className="fw-actions">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={() =>
            setScreen("/apply-new/referenceReview")
          }
        >
          Back
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--primary"
          onClick={() => {
            setSelfieFaceReady(false);
            setSelfieError("");

            // setSelfieFaceReady(false);
            // setSelfieError("");

            setSelfieHint(
              "Opening camera…"
            );

            setScreen("/apply-new/selfieCapture");
          }}
        >
          Proceed
        </button>
      </div>
    </section>
  );
};

export default SelfiePage;